var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHearts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 178.6 249.4",
    style: {
      enableBackground: "new 0 0 178.6 249.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 178.6,
    height: 249.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.7,42.6c-1.2-0.4-3.2,0.3-3.9,3.1c-0.1,0.2-0.1,0.2-0.2,0c-1-2.9-2.7-3.5-3.9-3.1c-1.7,0.6-3.2,2.7-3,5.4 c0,4.7,4.2,7,7.1,11.5c2.8-4.5,7.1-6.8,7.1-11.5C20.1,45.2,18.5,43.2,16.7,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8,59.5C12.7,59.5,12.7,59.5,12.8,59.5C12.7,59.5,12.7,59.5,12.8,59.5L12.8,59.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M165.9,189.9c-2.8,4.5-7.1,6.8-7.1,11.5c-0.2,2.7,1.3,4.8,3.1,5.3c1.2,0.4,3.2-0.3,3.9-3.1c0.1-0.2,0.1-0.1,0.2,0 c1,2.9,2.7,3.5,3.9,3.1c1.8-0.6,3.2-2.7,3.1-5.4C172.9,196.8,168.7,194.4,165.9,189.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.8,189.9L165.8,189.9C165.9,189.9,165.9,189.9,165.8,189.9L165.8,189.9z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ace_three_five_nine"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M89.3,146C89.3,146,89.2,145.9,89.3,146C89.2,145.9,89.2,146,89.3,146L89.3,146z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2,103.7c-3.1-1-8,0.7-9.8,7.8c-0.2,0.4-0.3,0.4-0.4,0c-2.6-7.2-6.8-8.7-9.8-7.8c-4.4,1.4-8,6.7-7.7,13.4 c0.1,11.7,10.6,17.6,17.6,28.8c7.1-11.2,17.7-17.1,17.7-28.8C107.6,110.3,103.8,105.1,99.2,103.7z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "two_three"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107,210.3c-0.1-11.7-10.6-17.6-17.7-28.8c-7.1,11.2-17.7,17.1-17.7,28.8c-0.6,6.8,3.2,12,7.7,13.4c3.1,1,8-0.7,9.7-7.8 c0.2-0.4,0.3-0.4,0.4,0c2.6,7.2,6.8,8.7,9.8,7.8C103.7,222.3,107.3,217,107,210.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2,25.8c-3.1-1-8,0.7-9.8,7.8c-0.2,0.4-0.3,0.4-0.4,0c-2.6-7.2-6.8-8.7-9.8-7.8c-4.4,1.4-8,6.7-7.7,13.4 C71.7,50.9,82.2,56.8,89.2,68c7.1-11.2,17.7-17.1,17.7-28.8C107.6,32.3,103.8,27.2,99.2,25.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "four_five_six_seven_eight"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56,22.9c-3.1-1-8,0.7-9.8,7.8c-0.2,0.4-0.3,0.4-0.5,0C43.2,23.6,39,22,36,22.9c-4.4,1.4-8,6.7-7.7,13.4 C28.5,48,38.9,53.9,46,65.1C53.1,53.9,63.7,48,63.7,36.3C64.3,29.5,60.5,24.3,56,22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8,210.3c-0.1-11.7-10.6-17.6-17.6-28.8c-7.1,11.2-17.7,17.1-17.7,28.8c-0.6,6.8,3.2,12,7.7,13.4c3.1,1,8-0.7,9.8-7.8 c0.2-0.4,0.3-0.4,0.5,0c2.6,7.2,6.8,8.7,9.8,7.8C60.5,222.3,64.1,217,63.8,210.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,22.9c-3.1-1-8,0.7-9.8,7.8c-0.1,0.4-0.3,0.4-0.4,0c-2.6-7.2-6.8-8.7-9.8-7.8c-4.4,1.4-8,6.7-7.7,13.4 c0.1,11.7,10.6,17.6,17.6,28.8C139.4,53.9,150,48,150,36.3C150.8,29.5,147,24.3,142.4,22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.2,210.3c-0.1-11.7-10.6-17.6-17.6-28.8c-7.1,11.2-17.7,17.1-17.7,28.8c-0.6,6.8,3.2,12,7.7,13.4c3.1,1,8-0.7,9.8-7.8 c0.1-0.4,0.3-0.4,0.4,0c2.6,7.2,6.8,8.7,9.8,7.8C147,222.3,150.5,217,150.2,210.3z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "six_seven_eight"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.4,102.3c-3.1-1-8,0.7-9.8,7.8c-0.1,0.4-0.3,0.4-0.4,0c-2.6-7.2-6.8-8.7-9.8-7.8c-4.4,1.4-8,6.7-7.7,13.4 c0.1,11.7,10.6,17.6,17.6,28.8c7.1-11.2,17.7-17.1,17.7-28.8C150.8,108.9,147,103.7,142.4,102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,102.3c-3.1-1-8,0.7-9.8,7.8c-0.2,0.4-0.3,0.4-0.5,0c-2.6-7.2-6.8-8.7-9.8-7.8c-4.4,1.4-8,6.7-7.7,13.4 c0.1,11.7,10.6,17.6,17.6,28.8c7.1-11.2,17.7-17.1,17.7-28.8C64.3,108.9,60.5,103.7,56,102.3z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "seven_eight_ten"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.2,56.9c-3.1-1-8,0.7-9.8,7.8c-0.2,0.4-0.3,0.4-0.4,0c-2.6-7.2-6.8-8.7-9.8-7.8c-4.4,1.4-8,6.7-7.7,13.4 C71.7,82,82.2,87.9,89.2,99.1c7.1-11.2,17.7-17.1,17.7-28.8C107.6,63.5,103.8,58.3,99.2,56.9z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "eight_ten"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107,169.2c-0.1-11.7-10.6-17.6-17.6-28.8c-7.1,11.2-17.7,17.1-17.7,28.8c-0.6,6.8,3.2,12,7.7,13.4c3.1,1,8-0.7,9.8-7.8 c0.2-0.4,0.3-0.4,0.4,0c2.6,7.2,6.8,8.7,9.8,7.8C103.7,181.2,107.3,175.9,107,169.2z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "nine_ten"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56,22.9c-3.1-1-8,0.7-9.8,7.8c-0.2,0.4-0.3,0.4-0.4,0C43.2,23.6,39,22,36,22.9c-4.4,1.4-8,6.7-7.7,13.4 C28.5,48,38.9,53.9,46,65.1C53.1,53.9,63.7,48,63.7,36.3C64.3,29.5,60.5,24.3,56,22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,75.8c-3.1-1-8,0.7-9.8,7.8c-0.2,0.4-0.3,0.4-0.4,0c-2.6-7.2-6.8-8.7-9.8-7.8c-4.4,1.4-8,6.7-7.7,13.4 c0.1,11.7,10.6,17.6,17.6,28.8c7.1-11.2,17.7-17.1,17.7-28.8C64.3,82.4,60.5,77.2,56,75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8,210.3c-0.1-11.7-10.6-17.6-17.6-28.8c-7.1,11.2-17.7,17.1-17.7,28.8c-0.6,6.8,3.2,12,7.7,13.4c3.1,1,8-0.7,9.8-7.8 c0.2-0.4,0.3-0.4,0.5,0c2.6,7.2,6.8,8.7,9.8,7.8C60.5,222.3,64.1,217,63.8,210.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8,157.4c-0.1-11.7-10.6-17.6-17.6-28.8c-7.1,11.2-17.7,17.1-17.7,28.8c-0.6,6.8,3.2,12,7.7,13.4c3.1,1,8-0.7,9.8-7.8 c0.2-0.4,0.3-0.4,0.5,0c2.6,7.2,6.8,8.7,9.8,7.8C60.5,169.4,64.1,164.1,63.8,157.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,22.9c-3.1-1-8,0.7-9.8,7.8c-0.1,0.4-0.3,0.4-0.4,0c-2.6-7.2-6.8-8.7-9.8-7.8c-4.4,1.4-8,6.7-7.7,13.4 c0.1,11.7,10.6,17.6,17.6,28.8C139.4,53.9,150,48,150,36.3C150.8,29.5,147,24.3,142.4,22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,75.8c-3.1-1-8,0.7-9.8,7.8c-0.1,0.4-0.3,0.4-0.4,0c-2.6-7.2-6.8-8.7-9.8-7.8c-4.4,1.4-8,6.7-7.7,13.4 c0.1,11.7,10.6,17.6,17.6,28.8c7.1-11.2,17.7-17.1,17.7-28.8C150.8,82.4,147,77.2,142.4,75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.2,210.3c-0.1-11.7-10.6-17.6-17.6-28.8c-7.1,11.2-17.7,17.1-17.7,28.8c-0.6,6.8,3.2,12,7.7,13.4c3.1,1,8-0.7,9.8-7.8 c0.1-0.4,0.3-0.4,0.4,0c2.6,7.2,6.8,8.7,9.8,7.8C147,222.3,150.5,217,150.2,210.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.2,157.4c-0.1-11.7-10.6-17.6-17.6-28.8c-7.1,11.2-17.7,17.1-17.7,28.8c-0.6,6.8,3.2,12,7.7,13.4c3.1,1,8-0.7,9.8-7.8 c0.1-0.4,0.3-0.4,0.4,0c2.6,7.2,6.8,8.7,9.8,7.8C147,169.4,150.5,164.1,150.2,157.4z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "jack_queen_king"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.6,213.2c-1.4,5.7-5.3,7-7.8,6.3c-3.6-1.1-6.7-5.3-6.2-10.7c0-9.5,8.5-14.2,14.2-23.2c5.7,9,14.1,13.7,14.2,23.1 c0.3,5.4-2.6,9.6-6.1,10.8c-2.4,0.7-5.8-0.5-7.9-6.3C131.9,213,131.7,212.9,131.6,213.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8,63.8c-5.7-9-14.1-13.7-14.2-23.1c-0.3-5.4,2.6-9.6,6.1-10.8c2.4-0.7,5.8,0.5,7.9,6.3c0.1,0.3,0.2,0.3,0.3,0 c1.4-5.7,5.3-7,7.8-6.3c3.6,1.1,6.7,5.3,6.2,10.7C61,50.1,52.5,54.8,46.8,63.8z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearts);
export default __webpack_public_path__ + "static/media/hearts.8a7deda958b5d7d2bf60dbfa5f8c7fe6.svg";
export { ForwardRef as ReactComponent };